import React from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';

const Footer = () => {
  const { t } = useTranslation('common');

  return (
    <footer className="bg-nautic text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <h3 className="text-lg font-semibold text-nautic-gold mb-4">{t('footer.contact')}</h3>
            <p className="text-sm">
              Email: <span className="text-nautic-gold">contact@nauticoach.com</span>
            </p>
            <div className="mt-4 flex items-center gap-2">
              <span className="text-sm">{t('language.label')} :</span>
              <LanguageSwitcher variant="dark" />
            </div>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold text-nautic-gold mb-4">{t('footer.quickLinks')}</h3>
            <ul className="text-sm space-y-2">
              <li><a href="/faq" className="hover:text-nautic-gold transition-colors">{t('footer.faq')}</a></li>
              <li><a href="/mentions-legales" className="hover:text-nautic-gold transition-colors">{t('footer.legalNotice')}</a></li>
              <li><a href="/politique-confidentialite" className="hover:text-nautic-gold transition-colors">{t('footer.privacy')}</a></li>
              <li><a href="/cgv" className="hover:text-nautic-gold transition-colors">{t('footer.cgv')}</a></li>
              <li><a href="/cgu" className="hover:text-nautic-gold transition-colors">{t('footer.cgu')}</a></li>
            </ul>
          </div>
        </div>
        
        <div className="mt-8 pt-8 border-t border-nautic-light text-center text-sm space-y-1">
          <div>{t('footer.rights')}</div>
          <div className="text-xs opacity-80">{t('footer.siret')}</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
